import React from 'react';
import PropTypes from 'prop-types';

import Workflow from './workflow';
import Header from './header';

import { Provider } from 'react-redux';
import { prepareWorkflow } from './store/workflow/reducer';
import configureStore from './store/configure';

import './styles.scss';

const VoucherApprovalWorkflowEditor = ({ users, workflow }) => {
  const store = configureStore({
    static: {
      roles: workflow.roles,
      users: users
    },
    workflow: prepareWorkflow(workflow)
  });

  return (
    <Provider store={store}>
      <div className="row">
        <div className="col-xs-12 task-workflow-editor">
          <Header />
          <Workflow />
        </div>
      </div>
    </Provider>
  );
};

VoucherApprovalWorkflowEditor.propTypes = {
  users: PropTypes.array.isRequired,
  workflow: PropTypes.object.isRequired
};

export default VoucherApprovalWorkflowEditor;
